import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/app/layouts/auth.vue").then(m => m.default || m)),
  base: defineAsyncComponent(() => import("/app/app/layouts/base.vue").then(m => m.default || m)),
  edi: defineAsyncComponent(() => import("/app/app/layouts/edi.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/app/layouts/empty.vue").then(m => m.default || m)),
  inventory: defineAsyncComponent(() => import("/app/app/layouts/inventory.vue").then(m => m.default || m))
}